module.exports = __webpack_public_path__ + "static/f10-f2f013c41fb7176ae0f172d526fc12ce.png";